export enum OrderStatus {
  pending = "PENDING",
  active = 'ACTIVE',
  unfulfilled = "UNFULFILLED",
  closed = "CLOSED"
}